import { Close, Done } from '@mui/icons-material';
import { Alert, Icon, IconButton, LinearProgress, Paper, TextField } from '@mui/material';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IUserCartItemList } from '../../_common/interface/userCartItem/iUserCartItemList';
import { PrimaryButton } from '../../_components/button/primary.button';
import { toastr } from '../../_components/toastr/toastr';
import { handleErrorResponse } from '../../_helpers/handleResponse.helper';
import { userCartService } from '../../_services/userCart.service';
import { userCartItemService } from '../../_services/userCartItem.service';

export default function UserCartItemIndex() {
    const { userCartId, userId } = useParams();

    const [data, setData] = useState<any>({});
    const [userCartStatus, setUserCartStatus] = useState<boolean>();
    const [isLoading, setLoading] = useState(false);
    const [discountCode, setDiscountCode] = useState("");

    const navigate = useNavigate();

    // const totalPrice = data.reduce((total, item) => total + item.price, 0);

    useEffect(() => {
        if (!userCartId) return;
        fetchData();
    }, [userCartId]);

    function fetchData() {
        setLoading(true);
        return userCartItemService.getAllByUserCartId(Number(userCartId))
            .then(
                data => {
                    setData(data);
                    //setUserCartStatus(data[0].userCartIsActive);

                }, (e) => { setData(null); handleErrorResponse(e); })
            .finally(() => {
                setLoading(false);
            });
    }

    function remove(id: number) {
        return userCartItemService
            .remove(id)
            .then(
                (d) => {
                    toastr.success("Disabled successfully");
                    fetchData();
                },
                (e) => {
                    toastr.error(e);
                }
            )
            .finally();
    }

    function updateDiscount() {
        return userCartService
            .updateDiscount(Number(userCartId), discountCode)
            .then(
                (d) => {
                    toastr.success("Discount code successfully applied");
                    fetchData();
                },
                (e) => {
                    toastr.error("Invalid discount code");
                }
            )
            .finally();
    }

    function handlePayment() {
        if (data.total === 0) {
            setLoading(true);
            return userCartService.complete(Number(userCartId))
                .then(
                    data => {
                        //setUserCartStatus(data[0].userCartIsActive);
                        toastr.success("Payment completed successfully");
                        navigate("../paymentConfirmation")
                    }, handleErrorResponse)
                .finally(() => {
                    setLoading(false);
                });
        }

        navigate('PaymentForm', {
            state: {
                userCartId: userCartId,
                amount: data.total
            },
        });
    };

    return (
        <Container maxWidth="md">
            <Paper sx={{ padding: 3 }}>

                <Typography variant="h3" textAlign='center' color="primary" marginBottom={2}>
                    User Cart {!!userCartId ? userCartId : ""}
                </Typography>

                {isLoading && <LinearProgress color="secondary" />}
                {(!isLoading && data) &&
                    <table style={{ width: "100%" }}>
                        <tr>
                            <th style={{ "textAlign": "left" }}>
                                Cart Item
                            </th>
                            <th style={{ "textAlign": "right", "paddingRight": "24px" }}>
                                Price
                            </th>
                            <th style={{ "width": "56px" }}>

                            </th>
                        </tr>
                        {(data && data.userCartItems) && data.userCartItems.map((item: IUserCartItemList) =>
                            <tr>
                                <td>
                                    <Typography variant="body1">{item.name}</Typography>
                                </td>
                                <td style={{ "paddingRight": "24px" }}>
                                    <Typography variant="body1" align="right">
                                        &euro;{item.price.toFixed(2)}
                                    </Typography>
                                </td>
                                <td>
                                    {item.isPaid ?
                                        <Done color="success" />
                                        :
                                        item.isRemovable &&
                                        <IconButton onClick={() => remove(item.id)} color="error">
                                            <Close />
                                        </IconButton>
                                    }
                                </td>
                            </tr>
                        )}

                        <tfoot>
                            {(!data.discount) &&

                                <tr>
                                    <td>
                                        <Typography variant="body1">Discount Code</Typography>
                                    </td>
                                    <td>
                                        <TextField style={{ "float": "right" }} id="outlined-basic" value={discountCode} onChange={(e) => { setDiscountCode(e.target.value) }} label="Discount Code" variant="standard" />
                                    </td>
                                    <td>
                                        <IconButton onClick={() => { updateDiscount() }} color="success">
                                            <Icon>check</Icon>
                                        </IconButton>
                                    </td>
                                </tr>
                            }

                            {(data.discount) &&
                                <tr>
                                    <td colSpan={2}>
                                        <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }} style={{ "paddingRight": "0px" }}>
                                            <Grid item xs={12} className="fullWidthAlert" style={{ "paddingLeft": "0px", "paddingRight": "0px" }}>
                                                <Alert severity="success">
                                                    <Grid container>
                                                        <Grid item xs={8}>
                                                            <span>Discount Code [{data.discount.code}: {data.discount.value}%]: </span>
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <span style={{ float: "right" }}>-&euro;{(data.discountAmount).toFixed(2)}</span>
                                                        </Grid>
                                                        {/* <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <IconButton onClick={() => removeDiscount()} color="error">
                                                        <Close />
                                                    </IconButton>
                                                </Grid> */}
                                                    </Grid>
                                                </Alert>
                                            </Grid>
                                        </Grid>
                                    </td>
                                </tr>
                            }

                            <tr style={{ "borderTop": "2px solid silver" }}>
                                <td style={{ "borderTop": "2px solid silver" }}>

                                </td>
                                <td style={{ "textAlign": "right", "borderTop": "2px solid silver" }}>
                                    <Typography variant="h6" fontWeight='bold'>
                                        Total: &euro;{data.total?.toFixed(2)}
                                    </Typography>
                                </td>
                                <td style={{ "borderTop": "2px solid silver" }}>

                                </td>
                            </tr>
                        </tfoot>
                    </table>
                }
                {/* 
                <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
                    <Grid item xs={8}>
                        <Typography variant="h6" fontWeight='bold'>
                            Cart Item
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="h6" fontWeight='bold' align="right">
                            Price
                        </Typography>
                    </Grid>
                    <Grid item xs={1} />
                </Grid>

                <Divider sx={{ mb: 2 }} />

                {data.map((item, index) => (
                    <Grid container spacing={2} key={index} alignItems="center" sx={{ mb: 1 }}>
                        <Grid item xs={8}>
                            <Typography variant="body1">{item.name}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" align="right">
                                &euro;{item.price.toFixed(2)}
                            </Typography>
                        </Grid>
                        <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {item.isPaid ?
                                <Done color="success" />
                                :
                                item.isRemovable &&
                                <IconButton onClick={() => remove(item.id)} color="error">
                                    <Close />
                                </IconButton>
                            }
                        </Grid>
                    </Grid>
                ))}


                <Divider sx={{ my: 2 }} />


                <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
                    <Grid item xs={12} className="fullWidthAlert">
                        <Alert severity="success">
                            <Grid container>
                                <Grid item xs={8}>
                                    <span>Discount Code [100%]: </span>
                                </Grid>
                                <Grid item xs={3}>
                                    <span style={{ float: "right" }}>&euro;{(25).toFixed(2)}</span>
                                </Grid>
                                <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <IconButton onClick={() => removeDiscount()} color="error">
                                        <Close />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Alert>
                    </Grid>
                </Grid>
                <Grid container spacing={2} direction="column" alignItems="flex-end">
                    <Grid item>
                        <Typography variant="h6" fontWeight='bold'>
                            Total: &euro;{totalPrice.toFixed(2)}
                        </Typography>
                    </Grid>
                    <Grid item>
                        {userCartStatus == true ?
                            <PrimaryButton
                                type="button"
                                variant="primary"
                                onClick={handlePayment}
                                icon="arrow_right"
                            >
                                Continue to Payment
                            </PrimaryButton>
                            : <Typography>The Payment for this Cart has been successfully processed.</Typography>

                        }
                    </Grid>
                </Grid>
 */}
                {!isLoading &&
                    <>
                        {(data && data.isActive) &&
                            <PrimaryButton
                                type="button"
                                variant="primary"
                                onClick={handlePayment}
                                icon="arrow_right"
                            >
                                Continue to Payment
                            </PrimaryButton>
                        }
                        {(data && !data.isActive) &&
                            <Typography>The Payment for this Cart has been successfully processed.</Typography>
                        }
                        {(!data) &&
                            <Typography>Unable to process payment information.</Typography>
                        }
                    </>}
            </Paper >
        </Container >

    );
};